<template>
  <div class="page">
    <MatchHeader />
    <MatchInfo />
    <BasketBallHome />
    <Footer />
  </div>
</template>

<script>
import MatchHeader from '../../layout/MatchHeader.vue'
import MatchInfo from '@comm/components/MatchInfo.vue'
import BasketBallHome from '@comm/components/match/basketball/BasketBallHome'
import Footer from '../../layout/Footer.vue'
export default {
  name: 'BasketBall',
  components: {
    MatchHeader,
    Footer,
    MatchInfo,
    BasketBallHome,
  },
  data() {
    return {}
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/backetball/home.vue